/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { StackComponent } from './stack';
export * from './stack-adapter';
export * from './stack-constants';
export * from './stack-core';
export * from './stack';
export function defineStackComponent() {
    defineCustomElement(StackComponent);
}
